import { render, staticRenderFns } from "./CompanyAccountHeaderTemplate.vue?vue&type=template&id=650ea065&"
import script from "./CompanyAccountHeaderTemplate.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountHeaderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports